"use client";

import { c as _c } from "react/compiler-runtime";
import { FolderIcon } from "lucide-react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useChatProject } from "@/hooks/useChatProjects";
interface ProjectContextBannerProps {
  projectId: string;
}

// Slim bar under the chat header showing that the current chat runs with a
// project's knowledge base and instructions.
export function ProjectContextBanner(t0) {
  const $ = _c(11);
  const {
    projectId
  } = t0;
  const {
    data
  } = useChatProject(projectId);
  const project = data?.project;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("orgId");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const orgIdParam = t1;
  if (!project) {
    return null;
  }
  const t2 = `/projects?id=${project.id}${orgIdParam ? `&orgId=${orgIdParam}` : ""}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FolderIcon className="h-3.5 w-3.5 shrink-0" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== project.name) {
    t4 = <span className="truncate font-medium">{project.name}</span>;
    $[3] = project.name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== project.fileCount) {
    t5 = project.fileCount > 0 && <span className="shrink-0">· {project.fileCount} {project.fileCount === 1 ? "file" : "files"}{" "}in knowledge base</span>;
    $[5] = project.fileCount;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="shrink-0 border-b bg-muted/40 px-4 py-1.5"><Link href={t2} className="inline-flex max-w-full items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">{t3}{t4}{t5}</Link></div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}